import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { getText, TEXT_KEY } from '../../utils/localization';
var KYCLockout = /*#__PURE__*/function (_Component) {
  function KYCLockout() {
    _classCallCheck(this, KYCLockout);
    return _callSuper(this, KYCLockout, arguments);
  }
  _inherits(KYCLockout, _Component);
  return _createClass(KYCLockout, [{
    key: "render",
    value: function render() {
      return this.props.render({
        title: getText(TEXT_KEY.KYC_LOCKOUT_TITLE),
        message: getText(TEXT_KEY.KYC_LOCKOUT_MESSAGE),
        buttonLabel: getText(TEXT_KEY.KYC_LOCKOUT_BUTTON_LABEL)
      });
    }
  }]);
}(Component);
export { KYCLockout as default };